/**
 * BattleGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleGetReq
 */
export interface BattleGetReq {
  /** 对线群ID，逗号分隔 */
  id: string
}

/**
 * BattleGetReq Schema
 */
export const BattleGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '对线群ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '对线群ID',
    },
  },
  required: ['id'],
  type: 'object',
}
